<template>
<div class="div-standard-container color-D">
	<div class="font-E color-A card-header">
        <span style="margin: auto">charge to credit card</span>
    </div>
    <div class="error_text">
    	<div style="height:10px;"></div>
	    <div class="error-message">
	        <div class="headline">Please correct the following and try again.</div>
	        <br />
	        <div class="error-body"><% VAR(error_text) %></div>
	    </div>
    </div>
    <div class="connectscreen_4.1">
    	<div class="required-fields-text">
            All fields are required
        </div>
        <div class="font-C-container">
            Please enter your payment information below.
            <br><br>
            <a href="http://www.google.com">Return to options.</a>
        </div>
    </div>
    <div class="default">
    	<div class="font-F-container font-back-link" style="padding-top:20px;">
            <a href="http://www.google.com">Back to options</a>
        </div>
        <div class="font-C-container">
            <span>Please enter your payment information below.</span>
        </div>
    </div>
    <div class="font-D-container creditField-container">
    	<div class="guest-info-container font-CreditField" style="">
            <span class="creditField-label field-label font-B-container">package</span>
            <% fPackageDropdown(4,0,1,0) %>
        </div>
        <div class="guest-info-container">
            <span class="creditField-label field-label font-B-container">
                first name
            </span>
            <input type="text" class="input-field" name="sFirstName" v-model="sFirstName">
        </div>
        <div class="guest-info-container">
            <span class="creditField-label field-label font-B-container">
                last name
            </span>
            <input type="text" class="input-field" name="sLastName" v-model="sLastName">
        </div>
        <div class="guest-info-container">
            <span class="creditField-label field-label font-B-container">
                zipcode
            </span>
            <input type="text" class="input-field" name="sZipcode" v-model="sZipcode">
        </div>
        <div class="guest-info-container font-CreditField" style="">
            <span class="creditField-label creditField-label field-label font-B-container">
                card type
            </span>
        </div>
        <div class="guest-info-container">
            <span class="creditField-label field-label font-B-container">
                card #
            </span>
            <input type="text" class="input-field" name="sCardNumber" v-model="sCardNumber">
        </div>
        <div class="guest-info-container">
            <span class="creditField-label field-label font-B-container">
                cvv/cvv2
            </span>
            <input type="text" class="input-field" name="sCardCID" v-model="sCardCID">
        </div>
        <div class="guest-info-container font-CreditField" style="">
            <span class="creditField-label field-label font-B-container">
                expiration
            </span>
            <span class="font-B-container">
                &nbsp;/&nbsp;
            </span>
        </div>
        <div class="guest-info-container">
            <span class="creditField-label field-label font-B-container">
                room number
            </span>
            <input class="input-field" type="text" id="sRoom" name="sRoom" placeholder="room number (optional)" v-model="sRoom">
        </div>
        <div class="guest-info-container">
            <span class="creditField-label field-label font-B-container">
                email
            </span>
            <input class="input-field" type="text" id="sEmail" name="sEmail" placeholder="email (optional)" v-model="sEmail">
        </div>
    </div>
    <div class="radisson_red">
    	<div id="radisson-red-tos-checkbox-wrapper">
            <input type="checkbox" value="1" id="radisson-red-tos-checkbox" />
            <label for="radisson-red-tos-checkbox" class="radisson-red-tos-label">
                I agree with the T's and C's <b style="color:#e62428;">*</b>
            </label>
        </div>
    </div>
    <div class="connect-button-inset-wrapper">
        <button class="button-0 font-E color-A connect-button">
            <div v-if="aCustomVars['layout'] == 'connectscreen_4.1'">
                continue
            </div>
            <div v-if="aCustomVars['layout'] != 'connectscreen_4.1'">
                connect
            </div>
        </button>
    </div>
</div>
</template>

<script>

export default {
  name: "CreditCardBody",
  data() {
    return {

    };
  }
}

</script>

<style scoped>

</style>